export default __webpack_public_path__ + "maps-examples-view-annotation-marker-thumbnail-960-f05e31c92f0c3da9a023d13cf832d3d7.webp";